var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.authSessionInvalidated)?_c('div',{attrs:{"role":"alert"}},[_vm._v(" Your session has changed in another tab. Reload to continue. "),_c('button',{attrs:{"type":"button"},on:{"click":_vm.reloadSession}},[_vm._v("Reload")])]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }